import React from 'react'

const context = React.createContext(undefined)

export default context

export const SessionProvider = context.Provider
